/**
 * The random tail of an app id (`btn-<base36 ms>-<tail>`). Eight base36
 * characters from the platform's CSPRNG.
 *
 * It was `Math.random().toString(36).slice(2, 6)`: four characters, and
 * sometimes fewer. Every id made in the same millisecond shares its time part,
 * so duplicating a 100-item page or pasting a group relied on four characters
 * alone, about a 0.3 % chance of two items sharing an id per 100-item copy; and
 * `editItem` / `removeItem` act on every item with that id (2026-11-03 audit
 * E-13). Eight characters is 2.8e12 values.
 */
export function idSuffix(): string {
  const bytes = new Uint8Array(8);
  globalThis.crypto.getRandomValues(bytes);
  let out = '';
  for (const b of bytes) out += (b % 36).toString(36);
  return out;
}
